import $axios from './config'

function spaseData (callBack) {
  $axios.get('/device/getDeviceIndustry', null, 'headers', function (res) {
    callBack(res)
    // if (res && res.resultStatus === true) {
    //   console.log(res)
    // } else {
    // }
  })
}

export default {
  spaseData
}



// WEBPACK FOOTER //
// ./src/https/data.js